import QueryParameterBuilder from '@/lib/query-parameter/QueryParameterBuilder';
import { gaiaApi } from '@/api';
import { gaiaConstantGroupType } from '@/constants/storeManagement/deliveryPossibleArea';
export default {
    async getSido() {
        const params = new QueryParameterBuilder();
        params.add('addressType', gaiaConstantGroupType.SI_DO);
        const response = await gaiaApi.getConstantGroup(params.build());
        return response.data;
    },
    async getSiGunGu({ parentLegalConstantGroupId, }) {
        const params = new QueryParameterBuilder();
        params.add('addressType', gaiaConstantGroupType.SI_GUN_GU);
        params.add('parentLegalConstantGroupId', parentLegalConstantGroupId);
        const response = await gaiaApi.getConstantGroup(params.build());
        return response.data;
    },
    async getEupMyeonDong({ parentLegalConstantGroupId, }) {
        const params = new QueryParameterBuilder();
        params.add('addressType', gaiaConstantGroupType.EUP_MYEON_DONG);
        params.add('parentLegalConstantGroupId', parentLegalConstantGroupId);
        const response = await gaiaApi.getConstantGroup(params.build());
        return response.data;
    },
};
